__turbopack_context__.v({
  "btnLogin": "styles-module-scss-module__-nqcRa__btnLogin",
  "button": "styles-module-scss-module__-nqcRa__button",
  "buttonLabel": "styles-module-scss-module__-nqcRa__buttonLabel",
  "buttonTitle": "styles-module-scss-module__-nqcRa__buttonTitle",
  "buttons": "styles-module-scss-module__-nqcRa__buttons",
  "imageContainer": "styles-module-scss-module__-nqcRa__imageContainer",
  "page": "styles-module-scss-module__-nqcRa__page",
  "smallText": "styles-module-scss-module__-nqcRa__smallText",
});
